import { zip, map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService, InspectionPluginService, DataService } from '../../shared/services';
import { Observable, of } from 'rxjs';
import { AssociateEqupmentFactoryService } from './associateequipment-plugin-factory.service';

@Injectable()
export class AssociateEquipmentService extends InspectionPluginService {
  public associateInspections: any[];
  public deletedInspectionIds = [];
  public addedInspectionIds = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private associatedFactory: AssociateEqupmentFactoryService
  ) {
    super(apiService, dataService, null, associatedFactory);
  }

  public updateAssociates(inspectionId: string, pluginId: string): Observable<any> {
    return this._updateAssociates(inspectionId, pluginId).pipe(
      map((inspections: any) => {
        this.dataService.updateChildren(
          inspectionId,
          this.associateInspections.map((a) => a.id)
        );
        this.dataService.deleteChildren(inspectionId, this.deletedInspectionIds);
        this.cancel();
      })
    );
  }

  public getInspections(inspectionId: string) {
    return this.dataService.getInspections().pipe(
      map((inspections) => {
        return inspections.filter(
          (i) => !this.associateInspections.some((a) => a.id === i.id) && i.id !== inspectionId
        );
      })
    );
  }

  public addInspections(inspections: any[]) {
    if (this.associateInspections) {
      this.associateInspections.push(...inspections);
    } else {
      this.associateInspections = [...inspections];
    }

    this.addedInspectionIds.push(...inspections.map((c) => c.id));

    this.deletedInspectionIds = this.deletedInspectionIds.filter((d) => !this.addedInspectionIds.includes(d));
  }

  public deleteInspection(inspection: any) {
    this.deletedInspectionIds.push(inspection.id);
    this.associateInspections = this.associateInspections.filter((a) => a.id !== inspection.id);
    this.addedInspectionIds = this.addedInspectionIds.filter((a) => !this.deletedInspectionIds.includes(a));
  }

  public setInspections(inspections: any[]) {
    this.associateInspections = [...inspections];
  }

  public cancel() {
    this.associateInspections = null;
    this.deletedInspectionIds = [];
    this.addedInspectionIds = [];
  }

  public deletePlugin(inspectionId: string, pluginId: string): any {
    return this.apiService
      .post(`/inspections/${inspectionId}/plugins/associate/${pluginId}`, {
        deletedInspectionIds: this.associateInspections.map((a) => a.id)
      })
      .pipe(
        zip(super.deletePlugin(inspectionId, null, pluginId)),
        map(([plugin, success]) => {
          this.dataService.deleteChildren(
            inspectionId,
            this.associateInspections.map((a) => a.id)
          );
          this.cancel();
          return success;
        })
      );
  }

  private _updateAssociates(inspectionId: string, pluginId: string): Observable<any> {
    const data = { deletedInspectionIds: this.deletedInspectionIds, addedInspectionIds: this.addedInspectionIds };
    return this.associatedFactory.updateAssociates(inspectionId, pluginId, data).pipe(
      flatMap((res) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(res);
        }
        return this.apiService.post(res.plugin.postServerUrl, res.plugin.config);
      })
    );
  }
}
